// Drawing review hasn't launched yet — keep its entry points out of production until
// REACT_APP_ENABLE_DRAWING_REVIEW=true is set (e.g. in a local .env for dev/testing).
export const DRAWING_REVIEW_ENABLED = process.env.REACT_APP_ENABLE_DRAWING_REVIEW === 'true';
